import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["theme", "loading", "size", "children", "beforeIcon", "afterIcon", "fullWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { useUiKitThemeContext } from '../../../internal/context';
import { getTheme } from '../../themes';
import { Spinner } from '../../../loader';
import customStyles from '../../styles/button.module.css';
import styles from '../../styles/shared.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ButtonComponent = /*#__PURE__*/React.forwardRef(function Button(_ref, ref) {
  let {
      theme = 'fill_primary',
      loading = false,
      size = 'M',
      children,
      beforeIcon,
      afterIcon,
      fullWidth
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    theme: globalTheme
  } = useUiKitThemeContext();
  const themeClasses = getTheme(theme);
  const buttonClasses = clsx(styles['button'], customStyles['button'], styles[size], themeClasses['button'], themeClasses[globalTheme], {
    [customStyles['loading']]: loading,
    [styles['full-width']]: fullWidth,
    [styles['button--before-icon']]: beforeIcon,
    [styles['button--after-icon']]: afterIcon
  });
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    className: buttonClasses
  }, rest), {}, {
    ref: ref,
    children: [loading && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['spinner'], customStyles['spinner'], themeClasses['spinner']),
      children: /*#__PURE__*/_jsx(Spinner, {
        color: "current_color",
        size: 16
      })
    }), beforeIcon, children && /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: children
    }), afterIcon]
  }));
});

/**
 * Компоненты кнопки. <br />
 * Компонет имеет настройки тем, размеров, умеет отображать прелоадер, иконки и текст. Кроме того кнопки меняют свое отображение в завсимости от пользовательских действий.
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=37831-25388&node-type=frame&t=HTw8sokOqTyz9FzP-0)
 */
export const Button = /*#__PURE__*/React.memo(ButtonComponent);